// deps
import React, { memo } from "react";

// types
import { IHeader } from "@dineout-payment-success-ui/interfaces";

// styles
import { CloseIconWrapper, HeaderWrapper } from "./styles";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

// test ids
import { PAYMENT_SUCCESS_HEADER } from "@swiggy-private/payment-test-ids";

const Header: React.FC<IHeader> = ({ title, description, onCloseButtonClick, showCloseIcon = true }) => {
    return (
        <HeaderWrapper>
            {showCloseIcon ? (
                <CloseIconWrapper data-testid={PAYMENT_SUCCESS_HEADER.CROSS_ICON} onClick={onCloseButtonClick}>
                    <SpriteIconWeb iconName="close12" />
                </CloseIconWrapper>
            ) : null}
            <div>
                <Text
                    variant="V2.heading1.neutral.black"
                    color="text_Highest_Emphasis"
                    data-testid={PAYMENT_SUCCESS_HEADER.RESTAURANT_NAME}
                >
                    {title}
                </Text>
                <Text
                    variant="V2.body2.neutral.regular"
                    color="text_Highest_Emphasis"
                    data-testid={PAYMENT_SUCCESS_HEADER.RESTAURANT_ADDRESS}
                >
                    {description}
                </Text>
            </div>
        </HeaderWrapper>
    );
};

export default memo(Header);
